var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.5v4.075l3.386 2.032a.75.75 0 0 1-.772 1.286l-3.75-2.25A.75.75 0 0 1 11.25 12V7.5a.75.75 0 1 1 1.5 0M21 5.25a.75.75 0 0 0-.75.75v1.688a41 41 0 0 0-1.886-2.047 9 9 0 1 0-.188 12.91.752.752 0 0 0-.494-1.297.75.75 0 0 0-.537.205 7.5 7.5 0 1 1 .156-10.765A42 42 0 0 1 19.406 9H17.25a.75.75 0 1 0 0 1.5H21a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75"
  })));
};
export default SvgTime;